import JSCookie from 'js-cookie';
import { Language } from '../core/lang/model';

interface PlayCookie {
  PLAY_LANG?: Language;
  PLAY_SESSION?: string;
  PLAY_FLASH?: string;
}

interface BVCookie {
  BV_CART?: string;
  BlueValetBack?: string;
}

type Cookie = Record<string, string> & PlayCookie & BVCookie;

export const getCookies = (): Cookie => JSCookie.get();

export const getLangFromCookies = () => getCookies().PLAY_LANG ?? Language.French;
